<template>
  <div>
    <button class="pdf-button" v-on:click="validateChecked(1)">Download Pdf</button>
    <button class="pdf-button" v-on:click="validateChecked(0)">Preview</button>
    <div class="company-reviews">
      <Reviews :reviews="this.$parent.getPdfData().company.posts"></Reviews>
    </div>
    <iframe id="pdf-preview" v-on:load="openPreview">closePreview
    </iframe>
    <button id="closePreviewBtn" v-on:click="closePreview">x</button>
  </div>
</template>

<script>
import Reviews from "@/components/Reviews.vue";
import {central_api_domain} from "@/constants/endpoints";

export default {
  name: "PDF",
  data() {
    return {
      centralAPIDomain: central_api_domain,
      graphUrl: "",
      negativePostsIndexes: [],
      indexes: [],
      init: true,
      company: {},
    }
  },
  components: {
    Reviews
  },
  methods: {
    validateChecked(option) {
      if (this.indexes.length === 3) {
        this.pdf(option);
      } else {
        alert("Please select 3 reviews before previewing or downloading the pdf." +
            "\n" + "Currently selected: " + this.indexes.length + " reviews.");
      }
    },
    pdf(download) {
      let companyId = this.$parent.getPdfData().companyId;
      
      let reviews = this.htmlEncode(this.company.posts[this.indexes[0]].id.toString()) + "," +
          this.htmlEncode(this.company.posts[this.indexes[1]].id.toString()) + "," +
          this.htmlEncode(this.company.posts[this.indexes[2]].id.toString());

      let uri = this.centralAPIDomain + "pdf/" + download + "," + companyId + "," + reviews;

      document.getElementById('pdf-preview').setAttribute("src", uri);
      if (download === 0) {
        this.openPreview();
      }
    },
    openPreview() {
      document.getElementById("pdf-preview").style.width = "800px";
      document.getElementById("pdf-preview").style.visibility = 'visible';
      document.getElementById("closePreviewBtn").style.visibility = 'visible';
    },
    closePreview() {
      document.getElementById("pdf-preview").style.width = "0px";
      document.getElementById("pdf-preview").style.visibility = 'hidden';
      document.getElementById("closePreviewBtn").style.visibility = 'hidden';
    },
    htmlEncode(string) {
      return string.replace(/\//g, '.').replace(/,/g, '@').replace(/\+/g, '_').replace(/=/g, '^').replace("?", ">");
    },
    pickReview(index) {
      if (event.target.checked) {
        if (!this.indexes.includes(index)) {
          this.indexes.push(index);
        }
      } else {
        for (let i = 0; i < this.indexes.length; i++) {
          if (this.indexes[i] === index) {
            this.indexes.splice(i, 1);
          }
        }
      }
    },
    wrapReviews() {
      let reviewContainters = document.getElementsByClassName("review-container box");

      for (let i = 0; i < reviewContainters.length; i++) {
        let htmlTemp = reviewContainters[i].innerHTML;
        reviewContainters[i].innerHTML = "<div id='" + i + "' class='reviewWrapper'><input type=\"checkbox\" ><br>" + htmlTemp + "</div>";
      }

    },
    checkFirstThreeNegativeCheckBoxes(negativeReviews) {
      //TODO only show button when >= 3 negative reviews.
      for (let j = 0; j < 3; j++) {
        document.getElementById(negativeReviews[j]).children[0].setAttribute("checked", "true");
      }
    },
    addChangeCheckboxEvent() {
      let pdfReviewCheckboxes = document.getElementsByClassName("reviewWrapper");
      for (let i = 0; i < pdfReviewCheckboxes.length; i++) {
        pdfReviewCheckboxes[i].addEventListener("change", () => this.pickReview(i));
      }
    },
    collectNegativeReviews() {
      let negativePostsIndexes = [];

      for (let i = 0; i < this.company.posts.length; i++) {
        if (this.company.posts[i].polarity === "Negatief") {
          negativePostsIndexes.push(i);
        }
      }
      return negativePostsIndexes;
    },
    selectTopThreeNegativeReviews() {
      if (this.negativePostsIndexes.length >= 3) {
        this.indexes = [];

        for (let i = 0; i < 3; i++) {
          this.indexes.push(this.negativePostsIndexes[i]);
        }
      }
    },
    transformReviewsToSelectable() {
      this.wrapReviews();
      this.checkFirstThreeNegativeCheckBoxes(this.negativePostsIndexes);
      this.addChangeCheckboxEvent();
    },
    initPdfPreview() {
      this.pdf(0);
    }
  },
  mounted() {
    this.company = this.$parent.getPdfData().company;
    this.negativePostsIndexes = this.collectNegativeReviews();

    this.selectTopThreeNegativeReviews();
    this.transformReviewsToSelectable();
    this.initPdfPreview();
  },
}
</script>
